import { render } from "./AddClassMomDialog.vue?vue&type=template&id=4a8cd2a3&scoped=true"
import script from "./AddClassMomDialog.vue?vue&type=script&lang=js"
export * from "./AddClassMomDialog.vue?vue&type=script&lang=js"

import "./AddClassMomDialog.vue?vue&type=style&index=0&id=4a8cd2a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8cd2a3"]])

export default __exports__